<template>
  <div style="width: 700px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto">
          <div slot="header" class="clearfix">
            <span>报价器-原神</span>
          </div>
          <div>
            <GIDan ref="fromSummit"></GIDan>
          </div>
          <div>
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="genPrice" style="margin-left: 5px" class="btnGen" id="btnGen">生成报价</el-button>
                  <el-button id="btnCopy" v-clipboard:copy="content" v-clipboard:success="onCopy" v-clipboard:error="onError" ref="btnCopy">复制报价</el-button>
                  <el-button @click="reset" id="btnReset">重置查询</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content" :autosize="{ minRows: 3, maxRows: 10 }"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top: 10px; margin-left: 10px; text-align: center">
      <el-alert title="空格键=生成报价+复制报价,回车键=复制报价!" type="success" center show-icon></el-alert>
    </div>
  </div>
</template>

<script>
  import GIDan from '../components/GIDan';

  export default {
    name: 'home',
    components: { GIDan },
    data() {
      return {
        gameId: 59,
        dans: this.$store.state.dans,
        selectedDans: [],
        zone: 'ANDRIOD',
        server: 'QQ',
        inscriptionId: 0,
        inscriptions: [],
        startStarCount: 1,
        endStarCount: 1,
        showEstimateTime: true,
        content: '',
        activeType: 'Dan',
        prompt: true,
      };
    },
    mounted() {
      this.loadInscriptions();
      this.loadQuoterTextFormat();
      this.enterKeyup();
    },
    computed: {
      sortedSelectedDans() {
        let target = [];

        Object.assign(target, this.selectedDans);
        target.sort((x, y) => {
          let xDanIndex = this.dans.findIndex(i => {
            return i.name === x.dan;
          });
          let yDanIndex = this.dans.findIndex(i => {
            return i.name === y.dan;
          });

          return xDanIndex - yDanIndex;
        });

        return target;
      },
    },
    methods: {
      loadInscriptions() {
        let url = '/api/company/inscriptions?gameId=' + this.gameId + '&pricingType=GOK_LEVELING';
        this.$http.get(url).then(res => {
          this.inscriptions = res.data;

          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id;
          }
        });
      },
      loadQuoterTextFormat() {
        let url = '/api/company/format?gameId=' + this.gameId + '&pricingType=GOK_LEVELING';
        this.$http.get(url).then(res => {
          let data = res.data;

          if (data != null) {
            this.showEstimateTime = data.showEstimateTime;
          }
        });
      },
      handleSelected(value) {
        let index = this.selectedDans.findIndex(x => {
          return x.dan === value.dan && x.subDan === value.subDan;
        });

        if (index === -1) {
          if (this.selectedDans.length === 2) {
            this.selectedDans.splice(0, 1);
          }
          this.selectedDans.push(value);
        } else {
          this.selectedDans.splice(index, 1);
        }
      },
      formatSubDan(subDan) {
        if (subDan === 'A' || subDan === 'B') {
          subDan = '';
        }
        return subDan;
      },
      genPrice(event) {
        let that = this;
        that.gokSummitPrice();
      },
      // 代练报价
      gokDanPrice() {
        let that = this;
        if (that.sortedSelectedDans.length == 0) {
          this.$message('请选择段位！');
          return false;
        }
        let startDan = that.sortedSelectedDans[0].label;
        let thatEndDan = 0;
        if (that.sortedSelectedDans.length == 1) {
          thatEndDan = that.sortedSelectedDans[0].label;
        } else {
          thatEndDan = that.sortedSelectedDans[1].label;
        }
        let data = {
          gameId: this.gameId,
          zone: this.zone,
          server: this.server,
          fromDan: startDan,
          fromStarCount: this.startStarCount,
          endDan: thatEndDan,
          endStarCount: this.endStarCount,
          inscriptionId: this.inscriptionId,
          showTime: this.showEstimateTime,
        };

        this.$http.post('/api/gok/price/dan', data).then(res => {
          if (res == null) {
            return;
          }

          this.content = res.data;
          this.doCopy(this.content);
          this.$message('原神报价生成成功！');
        });
      },
      // 战力报价
      gokBattlePrice() {
        let that = this;
        let from = that.$refs['fromBattle'].fromBattle;
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint,
        };
        this.$http.post('/api/gok/price/battle', data).then(res => {
          if (res == null) {
            return;
          }

          this.content = res.data;
          this.doCopy(this.content);
          this.$message('原神报价生成成功！');
        });
      },
      // 巅峰赛报价
      gokSummitPrice() {
        let that = this;
        let from = that.$refs['fromSummit'].fromSummit;
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          showTime: from.showTime,
          toPoint: from.toPoint,
        };
        this.$http.post('/api/gi/price/adventure', data).then(res => {
          if (res == null) {
            return;
          }

          this.content = res.data;
          this.doCopy(this.content);
          this.$message('代练报价生成成功！');
        });
      },
      reset() {
        let that = this;
        if (that.activeType === 'Dan') {
          this.selectedDans = [];
          this.startStarCount = 1;
          this.endStarCount = 1;
          this.zone = 'ANDRIOD';
          this.server = 'QQ';
          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id;
          }
        } else if (that.activeType === 'Battle') {
          that.$refs['fromBattle'].fromBattle.fromPoint = '';
          if (that.$refs['fromBattle'].fromBattle.inscriptions.length > 0) {
            that.$refs['fromBattle'].fromBattle.inscriptionId = that.$refs['fromBattle'].fromBattle.inscriptions[0].id;
          }
          that.$refs['fromBattle'].fromBattle.showTime = true;
          that.$refs['fromBattle'].fromBattle.toPoint = '';
        } else if (that.activeType === 'Summit') {
          that.$refs['fromSummit'].fromSummit.fromPoint = '';
          if (that.$refs['fromSummit'].fromSummit.inscriptions.length > 0) {
            that.$refs['fromSummit'].fromSummit.inscriptionId = that.$refs['fromSummit'].fromSummit.inscriptions[0].id;
          }
          that.$refs['fromSummit'].fromSummit.showTime = true;
          that.$refs['fromSummit'].fromSummit.toPoint = '';
        }
        this.$message('重置成功');
      },
      onCopy(e) {
        this.$message('内容已复制到剪切板！');
      },
      // 复制失败时的回调函数
      onError(e) {
        this.$message('抱歉，您的浏览器不支持！');
      },
      doCopy(e) {
        let that = this;
        that.$copyText(this.content).then(
          function (e) {
            that.$message('内容已复制到剪切板');
          },
          function (e) {
            if (that.prompt) {
              that.prompt = false;
              that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！');
            }
          }
        );
      },
      enterKeyupDestroyed() {
        document.removeEventListener('keyup', this.enterKey);
      },
      enterKeyup() {
        document.addEventListener('keyup', this.enterKey);
      },
      enterKey(event) {
        const componentName = this.$options.name;

        if (componentName == 'home') {
          const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;

          if (code == 32) {
            this.genPrice();
          } else if (code == 13) {
            this.doCopy();
          }
        }
      },
      showMessage(msg, duration) {
        let that = this;
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration,
        });
      },
    },
    destroyed() {
      let that = this;
      that.$message.closeAll();
      that.enterKeyupDestroyed();
    },
    beforeDestroy() {
      // 销毁enter事件
      this.enterKeyupDestroyed();
    },
  };
</script>

<style lang="stylus" scoped>
  .desc_text {
    height 40px;
    line-height 40px;
    margin-right 5px;
  }
</style>
